import React from 'react';
import styles from '../index.module.scss';
import { useFormContext } from 'react-hook-form';
import { ReactComponent as LocationIcon } from '../../../../../../../../assets/icons/locationIcon.svg';
import { InputAdornment } from '@mui/material';
import TextField from '../../../../../../../Inputs/TextField';
import classNames from 'classnames';
import useIntakeBlockToggle, {
  intakeBlocksEnum,
} from '../../../../hooks/useIntakeBlockToggle';

const AddressField = () => {
  const { register } = useFormContext();
  const { isOn, isRequired } = useIntakeBlockToggle();

  if (!isOn(intakeBlocksEnum.address)) {
    return null;
  }

  return (
    <TextField
      label="Address"
      wrapperClassName={classNames(
        styles.inputWrapper,
        styles.largeInputWrapper
      )}
      inputClassName={styles.inputField}
      placeholder="Insert address here"
      {...register('address', {
        required: isRequired(intakeBlocksEnum.address)
          ? 'Please enter address'
          : '',
      })}
      required={isRequired(intakeBlocksEnum.address)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <LocationIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default AddressField;
